<template>
  <div></div>
</template>
<script>
export default {
  name: "vFormElementMixin",
  props: {
    steps: {type: Array, default: () => {return []}},
    globals: {type: Object, default: () => {return {}}},
    element: {type: Object, required: true},
    organizationId: {type: String, default: ""},
    projectId: {type: String, required: true},
    vSTAGEContext: {type: Boolean, default: false},
    selectedTemplate: {type: Object, default: () => {return {}}},
    templateEditing: {type: Boolean, default: false},
  },
  data() {
    return {
      forceReRenderKey: 0
    }
  },
  watch: {
    "element.label": {
      deep: true,
      handler: function () {
        this.$emit("dirty");
      },
    },
    "element.options": {
      deep: true,
      handler: function () {
        this.$emit("dirty");
      },
    },
    "element.fields": {
      deep: true,
      handler: function () {
        this.$emit("dirty");
      },
    },
  },
  methods: {
    setItemColor(propertyName, color) {
      this.$set(this.element, propertyName, color);
    },
    isObjectEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
  }
};
</script>